import React from 'react';
import { IconProps } from './types';

const AudioPlaceHolder: React.FC<IconProps> = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      width="60"
      height="52"
      viewBox="0 0 60 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_7109_70149)">
        <rect x="20" y="8" width="36" height="36" rx="4" fill="white" />
      </g>
      <mask
        id="mask0_7109_70149"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="28"
        y="14"
        width="24"
        height="24"
      >
        <rect x="28" y="14" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7109_70149)">
        <path
          d="M40.0001 28C39.1667 28 38.4584 27.7083 37.8751 27.125C37.2917 26.5417 37.0001 25.8333 37.0001 25V19C37.0001 18.1667 37.2917 17.4583 37.8751 16.875C38.4584 16.2917 39.1667 16 40.0001 16C40.8334 16 41.5417 16.2917 42.1251 16.875C42.7084 17.4583 43.0001 18.1667 43.0001 19V25C43.0001 25.8333 42.7084 26.5417 42.1251 27.125C41.5417 27.7083 40.8334 28 40.0001 28ZM39.0001 34V31.925C37.4667 31.7083 36.1542 31.0583 35.0626 29.975C33.9709 28.8917 33.3084 27.575 33.0751 26.025C33.0417 25.7417 33.1167 25.5 33.3001 25.3C33.4834 25.1 33.7167 25 34.0001 25C34.2834 25 34.5209 25.0958 34.7126 25.2875C34.9042 25.4792 35.0334 25.7167 35.1001 26C35.3334 27.1667 35.9126 28.125 36.8376 28.875C37.7626 29.625 38.8167 30 40.0001 30C41.2001 30 42.2584 29.6208 43.1751 28.8625C44.0917 28.1042 44.6667 27.15 44.9001 26C44.9667 25.7167 45.0959 25.4792 45.2876 25.2875C45.4792 25.0958 45.7167 25 46.0001 25C46.2834 25 46.5167 25.1 46.7001 25.3C46.8834 25.5 46.9584 25.7417 46.9251 26.025C46.6917 27.5417 46.0334 28.85 44.9501 29.95C43.8667 31.05 42.5501 31.7083 41.0001 31.925V34C41.0001 34.2833 40.9042 34.5208 40.7126 34.7125C40.5209 34.9042 40.2834 35 40.0001 35C39.7167 35 39.4792 34.9042 39.2876 34.7125C39.0959 34.5208 39.0001 34.2833 39.0001 34Z"
          fill="#CCE4FF"
        />
      </g>
      <g filter="url(#filter1_d_7109_70149)">
        <rect x="4" width="36" height="36" rx="4" fill="white" />
      </g>
      <mask
        id="mask1_7109_70149"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="6"
        width="24"
        height="24"
      >
        <rect x="10" y="6" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask1_7109_70149)">
        <path
          d="M22.0001 20C21.1667 20 20.4584 19.7083 19.8751 19.125C19.2917 18.5417 19.0001 17.8333 19.0001 17V11C19.0001 10.1667 19.2917 9.45833 19.8751 8.875C20.4584 8.29167 21.1667 8 22.0001 8C22.8334 8 23.5417 8.29167 24.1251 8.875C24.7084 9.45833 25.0001 10.1667 25.0001 11V17C25.0001 17.8333 24.7084 18.5417 24.1251 19.125C23.5417 19.7083 22.8334 20 22.0001 20ZM21.0001 26V23.925C19.4667 23.7083 18.1542 23.0583 17.0626 21.975C15.9709 20.8917 15.3084 19.575 15.0751 18.025C15.0417 17.7417 15.1167 17.5 15.3001 17.3C15.4834 17.1 15.7167 17 16.0001 17C16.2834 17 16.5209 17.0958 16.7126 17.2875C16.9042 17.4792 17.0334 17.7167 17.1001 18C17.3334 19.1667 17.9126 20.125 18.8376 20.875C19.7626 21.625 20.8167 22 22.0001 22C23.2001 22 24.2584 21.6208 25.1751 20.8625C26.0917 20.1042 26.6667 19.15 26.9001 18C26.9667 17.7167 27.0959 17.4792 27.2876 17.2875C27.4792 17.0958 27.7167 17 28.0001 17C28.2834 17 28.5167 17.1 28.7001 17.3C28.8834 17.5 28.9584 17.7417 28.9251 18.025C28.6917 19.5417 28.0334 20.85 26.9501 21.95C25.8667 23.05 24.5501 23.7083 23.0001 23.925V26C23.0001 26.2833 22.9042 26.5208 22.7126 26.7125C22.5209 26.9042 22.2834 27 22.0001 27C21.7167 27 21.4792 26.9042 21.2876 26.7125C21.0959 26.5208 21.0001 26.2833 21.0001 26Z"
          fill="#0276FE"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_7109_70149"
          x="16"
          y="8"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.7875 0 0 0 0 0.7875 0 0 0 0 0.7875 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7109_70149" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7109_70149"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_7109_70149"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.7875 0 0 0 0 0.7875 0 0 0 0 0.7875 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7109_70149" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7109_70149"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AudioPlaceHolder;
